import { Pages } from 'modules/navigation/domain/enums/pages';
import { ChampionshipEncoded } from 'modules/championship/domain/interfaces/championship-encoded';
import React, { useCallback, useEffect, useMemo } from 'react';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import ChampionshipCreateForm from 'modules/championship/ui/components/create-form';
import { trackEvent } from 'shared/analytics';

const ChampionshipCreatePage = () => {
  const onSave = useCallback((_: Partial<ChampionshipEncoded>) => {}, []);
  const { setHeaderContent } = useMainLayout();

  const breadcrumbsItems = useMemo(() => {
    return [
      {
        label: 'Создание турнира',
        to: Pages.CHAMPIONSHIPS.CREATE,
      },
    ];
  }, []);

  const breadcrumbs = useMemo(() => <UDBreadcrumbs className="my-10" breadcrumbs={breadcrumbsItems} />, [breadcrumbsItems]);

  // Первый шаг воронки создания турнира. Страница монтируется один раз на визит, поэтому у
  // эффекта нет зависимостей: событие должно уйти ровно однажды за визит на страницу.
  useEffect(() => {
    trackEvent('Championship Create Started', {});
  }, []);

  useEffect(() => {
    setHeaderContent(breadcrumbs);

    return () => {
      setHeaderContent(null);
    };
  }, [breadcrumbs, setHeaderContent]);

  return <ChampionshipCreateForm onSubmit={onSave} />;
};

export default ChampionshipCreatePage;
